import { render, staticRenderFns } from "./storicoLotti.vue?vue&type=template&id=7af5cd49"
import script from "./storicoLotti.vue?vue&type=script&lang=js"
export * from "./storicoLotti.vue?vue&type=script&lang=js"
import style0 from "./storicoLotti.vue?vue&type=style&index=0&id=7af5cd49&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports